import React, { useState } from 'react';
import { map, size, get, replace } from 'lodash';
import moment from 'moment';
import { GRAY_DARK, WHITE } from '../../../utils/colors';
import { Button, FlexContainer, FormDatePicker, FormInput, If, SpaceBetween } from '../../common';
import { onlyNumbers } from '../../../utils/Regex';

const Filters = () => {
    const [ean, setEan] = useState(null);
    const [email, setEmail] = useState(null);
    const [date, setDate] = useState(moment());

    const buttonProperties = {
        width: 100,
        Component: Button
    };

    const fields = [
        {
            label: 'EAN',
            placeholder: 'Ingresa código',
            onChange: ({ target }) => setEan(replace(get(target, 'value', ''), onlyNumbers, '')),
            value: ean
        },
        {
            label: 'Email',
            placeholder: 'Ingresa email',
            onChange: ({ target }) => setEmail(get(target, 'value', null)),
            value: email
        },
        {
            label: 'Fecha creación',
            Component: FormDatePicker,
            onChange: value => setDate(value[0]),
            defaultValue: moment(),
            value: date
        }
    ];

    const buttons = [
        {
            text: 'Limpiar',
            link: true,
            right: 10,
            ...buttonProperties
        },
        {
            text: 'Buscar',
            ...buttonProperties
        }
    ];

    return (
        <FlexContainer
            marginHorizontal={33}
            marginVertical={16}
            padding={16}
            backgroundColor={WHITE}
            align='center'
            borderRadius={4}
            border={`0.5px solid ${GRAY_DARK}`}
        >
            { map([...fields, ...buttons], ({ Component = FormInput, ...properties }, index) => (
                <>
                    <Component
                        key={index}
                        {...properties}
                    />
                    <If
                        condition={size(fields) !== index + 1}
                        then={<SpaceBetween />}
                    />
                </>
            )) }
        </FlexContainer>
    );
};

export default Filters;
